// 加载全局配置
import "./configs";
//import 'amfe-flexible'
import set_flexible from '@/utils/flexible.js'

set_flexible();

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { i18n } from "./i18n";
import * as apis from "@/api";
import {
  canShowFeature,
  normalizeFeatureAccess,
} from "@/utils/feature-access";
import dayjs from "dayjs";
import { imgfilter } from "@/tool";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import "animate.css";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI);

import happyCoinMixin from "@/mixins/happy-coin";
Vue.mixin(happyCoinMixin);

const options = {
  transition: "Vue-Toastification__bounce",
  maxToasts: 1,
  newestOnTop: true,
  position: "top-right",
  timeout: 2500,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
  filterToasts: (toasts) => {
    // Keep track of existing types
    const types = {};
    return toasts.reduce((aggToasts, toast) => {
      // Check if type was not seen before
      if (!types[toast.type]) {
        aggToasts.push(toast);
        types[toast.type] = true;
      }
      return aggToasts;
    }, []);
  },
};

Vue.use(Toast, options);

//图片转换
Vue.filter("imgfilter", imgfilter);
Vue.prototype["$imgfilter"] = imgfilter;
Vue.prototype.$canShowFeature = (featureKey) =>
  canShowFeature(store.state.featureAccess, featureKey);


Vue.config.productionTip = false;

import {
  Swiper as SwiperClass,
  Autoplay,
  Pagination,
  Lazy,
  Virtual,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper.less";
import "swiper/components/pagination/pagination.less";
import "swiper/components/lazy/lazy.less";
SwiperClass.use([Autoplay, Pagination, Lazy, Virtual]);
Vue.use(getAwesomeSwiper(SwiperClass));

import VueAnimateNumber from "vue-animate-number";
Vue.use(VueAnimateNumber);

import svgSprite from "@/components/svg-sprite";
Vue.component("c-svg", svgSprite);

import headerReturn from "@/components/headerReturn";
Vue.component("c-header-return", headerReturn);

import "view-design/dist/styles/iview.css";
import Message from "view-design/src/components/message";
import Modal from "view-design/src/components/modal";
import Circle from "view-design/src/components/circle";
import Switch from "view-design/src/components/switch";
import Menu from "view-design/src/components/menu";
import Page from "view-design/src/components/page";
import Form from "view-design/src/components/form";
import Input from "view-design/src/components/input";
import InputNumber from "view-design/src/components/input-number";
import DatePicker from "view-design/src/components/date-picker";
import Tooltip from "view-design/src/components/tooltip";
import Badge from "view-design/src/components/badge";
import Poptip from "view-design/src/components/poptip";
import Slider from "view-design/src/components/slider";
import Rate from "view-design/src/components/rate";
import Upload from "view-design/src/components/upload";
import Select from "view-design/src/components/select";
import Option from "view-design/src/components/option";
import Drawer from "view-design/src/components/drawer";
import Dropdown from "view-design/src/components/dropdown";
import DropdownMenu from "view-design/src/components/dropdown-menu";
import DropdownItem from "view-design/src/components/dropdown-item";
import Row from "view-design/src/components/row";
import Col from "view-design/src/components/col";
import Card from "view-design/src/components/card";
import Icon from "view-design/src/components/icon";
import Button from "view-design/src/components/button";
import Table from "view-design/src/components/table";
import Alert from "view-design/src/components/alert";
import Spin from "view-design/src/components/spin";
import RadioGroup from "view-design/src/components/radio-group";
import Radio from "view-design/src/components/radio";
import VueGtag from 'vue-gtag';

import ConvertDirective from './directives/convert.js';
//import TippyDirective from './directives/tippy.js';

Vue.directive('convert', ConvertDirective);
//Vue.directive('tippy', TippyDirective);

Vue.prototype.$Message = Message;
Vue.component("Modal", Modal);
Vue.component("i-circle", Circle);
Vue.component("i-switch", Switch);
Vue.component("Menu", Menu);
Vue.component("MenuItem", Menu.Item);
Vue.component("Submenu", Menu.Sub);
Vue.component("Page", Page);
Vue.component("Form", Form);
Vue.component("FormItem", Form.Item);
Vue.component("Input", Input);
Vue.component("InputNumber", InputNumber);
Vue.component("DatePicker", DatePicker);
Vue.component("Tooltip", Tooltip);
Vue.component("Badge", Badge);
Vue.component("Poptip", Poptip);
Vue.component("Slider", Slider);
Vue.component("Rate", Rate);
Vue.component("Upload", Upload);
Vue.component("Select", Select);
Vue.component("Option", Option);
Vue.component("Drawer", Drawer);
Vue.component("Dropdown", Dropdown);
Vue.component("DropdownMenu", DropdownMenu);
Vue.component("DropdownItem", DropdownItem);
Vue.component("Row", Row);
Vue.component("Col", Col);
Vue.component("Card", Card);
Vue.component("Icon", Icon);
Vue.component("Button", Button);
Vue.component("Table", Table);
Vue.component("Alert", Alert);
Vue.component("Spin", Spin);
Vue.component("RadioGroup", RadioGroup);
Vue.component("Radio", Radio);

import {
  set_official_loading,
  set_messageData,
  set_scrape,
} from "./tool/index.js";

Vue.prototype.set_official_loading = set_official_loading;
Vue.prototype.set_messageData = set_messageData;
Vue.prototype.set_scrape = set_scrape;
//Vue.prototype.calculation = calculation

import PortalVue from "portal-vue";
Vue.use(PortalVue);

import VueScreen from "vue-screen";
Vue.use(VueScreen, {
  mobile: (screen) => screen.width <= 768,
  notebook: (screen) => screen.width <= 1366,
});

import VueQriously from "vue-qriously";
Vue.use(VueQriously);

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

import VueQr from "vue-qr";
Vue.use(VueQr);

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import caseBattleHub from "@/tool/websocket/caseBattle.js";
Vue.prototype.$caseBattleHub = caseBattleHub;

import mpCaseHub from "@/tool/websocket/mpCase.js";
Vue.prototype.$mpCaseHub = mpCaseHub;

import chatRoomHub from "@/tool/websocket/chatRoom.js";
Vue.prototype.$chatRoomHub = chatRoomHub;

import crashHub from "@/tool/websocket/crashSocket.js";
Vue.prototype.$crashHub = crashHub;

import wheelHub from "@/tool/websocket/wheelSocket.js";
Vue.prototype.$wheelHub = wheelHub;

// import Bugsnag from '@bugsnag/js'
// import BugsnagPluginVue from '@bugsnag/plugin-vue'

// Bugsnag.start({
//   apiKey: '34e69d863773c2726e4047d9b9e7b968',
//   plugins: [new BugsnagPluginVue()]
// })

// const bugsnagVue = Bugsnag.getPlugin('vue')
// bugsnagVue.installVueErrorHandler(Vue)


Vue.use(VueGtag, {
  config: { id: 'G-TXZCE2RB7E' }, // ← 這裡換成你的 GA ID
  appName: 'KJcs2',               // 可以選填，會當作 GA 的 app name
  pageTrackerScreenviewEnabled: true, // 若需要使用 screenview，可開啟
}, router)

let vueObj;

const mountApp = () => {
  vueObj = new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount("#app");
};

apis
  .api_GetFeatureAccess()
  .then((res) => {
    if (res.data.code === 0) {
      store.commit("setFeatureAccess", normalizeFeatureAccess(res.data.data));
    }
  })
  .catch(() => {})
  .finally(mountApp);

export { vueObj };
